import { render, staticRenderFns } from "./horizontal-tabs-component.vue?vue&type=template&id=4c6deb3b&scoped=true&"
import script from "./horizontal-tabs-component.vue?vue&type=script&lang=ts&"
export * from "./horizontal-tabs-component.vue?vue&type=script&lang=ts&"
import style0 from "./horizontal-tabs-component.vue?vue&type=style&index=0&id=4c6deb3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6deb3b",
  null
  
)

export default component.exports